import { Controller } from "@hotwired/stimulus"

// Shows a picked file in an existing <img> before the form is submitted. Each
// file input passes a data-image-preview-name-param naming the image target
// (matched on its data-name) it previews, so one controller on the form can
// handle several file fields. An image target with a data-preview-alt gets
// that alt while it shows the preview.
export default class extends Controller {
  static targets = ["image"]

  #objectUrls = new Map()

  show({ target, params: { name } }) {
    const image = this.imageTargets.find((element) => element.dataset.name === name)
    const file = target.files?.[0]
    if (!image || !file?.type.startsWith("image/")) return

    this.#revoke(name)
    const url = URL.createObjectURL(file)
    this.#objectUrls.set(name, url)
    image.src = url
    if (image.dataset.previewAlt) image.alt = image.dataset.previewAlt
  }

  disconnect() {
    for (const name of this.#objectUrls.keys()) this.#revoke(name)
  }

  #revoke(name) {
    const url = this.#objectUrls.get(name)
    if (!url) return

    URL.revokeObjectURL(url)
    this.#objectUrls.delete(name)
  }
}
